module.exports = __webpack_public_path__ + "img/lb-btn-video.c05519e9.svg";